import React, { useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import moment from 'moment';

import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
import Swal from 'sweetalert2';
import { C_GREEN} from '../../../../extras/colors';
import ButtonSpinner from '../../../../layout/ButtonSpinner'
import clienteAxios from '../../../../../config/axios';
import binaries from '../../../../../data/binaryData';
//Redux
import { useDispatch } from 'react-redux';
import { rollbackAudienceAction } from '../../../../../actions/audiencesActions';
import { ErrorMessage } from '../../../../extras/toastMessages';
//Función principal
const RollBackForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Genero los ref
    const refMotivo = useRef();
    //Inicializo datos
    const initialData = {
        motivo: ''
    }
    //Inicializo el state local
    const [loading, setLoading] = useState(false);
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refMotivo.current.focus();
    }
    //Método para guardar el agendamiento
    const rollback=values=>{
        //Armo los datos
        const data =  values.motivo
        //Llamo al dispatch
        dispatch( rollbackAudienceAction(audience, data, handleClose) );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        motivo: yup.string().required()
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Volver a estado Agendada</strong> <small>(Audiencia #{ audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => rollback(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        A continuación ingrese el motivo por el cual cambia de estado esta audiencia
                                    </div>
                                </div>
                                <div className="col-12">
                                    Fecha Solicitud: <strong>{ audience.fechaSolicitud ? moment(audience.fechaSolicitud).format('DD/MM/YYYY HH:mm') : '' }</strong>
                                    <hr/>
                                </div>
                                <Form.Group className="col-12">
                                    <label htmlFor="motivo">Motivo</label>
                                    <Form.Control
                                        id="motivo"
                                        className="form-control" 
                                        autoFocus 
                                        name="motivo" 
                                        as="textarea" 
                                        placeholder="Ingrese un motivo"
                                        value={ values.motivo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.motivo}
                                        disabled={ loading }
                                        ref={refMotivo}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.motivo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>Aceptar</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default RollBackForm;